'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/react-fast-compare/index.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function useValues() {
  var initialValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var [values, setValues] = React__namespace.useState({});
  var [originalValues, setOriginalValues] = React__namespace.useState({});
  var setFieldValue = React__namespace.useCallback((field, value) => setValues(_rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, values), {}, {
    [field]: value
  })), [values]);
  var resetValues = React__namespace.useCallback(() => {
    setValues(_rollupPluginBabelHelpers.objectSpread2({}, initialValues));
    setOriginalValues(_rollupPluginBabelHelpers.objectSpread2({}, initialValues));
  }, [initialValues]);
  var isDirty = !index(values, originalValues); // Reset values whenever the initialValues input changes.

  React__namespace.useEffect(() => {
    setValues(_rollupPluginBabelHelpers.objectSpread2({}, initialValues));
    setOriginalValues(_rollupPluginBabelHelpers.objectSpread2({}, initialValues));
  }, deps);
  return {
    values,
    setValues,
    setFieldValue,
    resetValues,
    isDirty
  };
}

exports.default = useValues;
exports.useValues = useValues;
